import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['input', 'image', 'preview', 'removeFlag']
  static values = {
    defaultImageUrl: String
  }

  connect() {
    this.fileReader = new FileReader();
    this.fileReader.addEventListener('load', (event) => {
      this.imageTarget.src = event.target.result
      this.element.classList.remove('empty')
    });

    this.element.addEventListener('dragenter', (e) => this.onDragEnter(e))
    this.element.addEventListener('dragleave', (e) => this.onDragLeave(e))
    this.element.addEventListener('drop', (e) => this.onDrop(e))
  }

  fileChanged(e) {
    this.fileReader.readAsDataURL(e.target.files[0])
  }

  markToRemove(e) {
    this.removeFlagTarget.checked = true
    this.imageTarget.src = this.defaultImageUrlValue
    this.removeFlagChanged(e)
  }

  removeFlagChanged(e) {
    if (this.removeFlagTarget.checked) {
      this.element.classList.add('empty')
      this.inputTarget.disabled = false
    } else {
      this.element.classList.remove('empty')
      this.inputTarget.disabled = false
    }
  }

  onDragEnter(e) {
    e.preventDefault()
    this.element.classList.add('drag-over')
  }

  onDragLeave(e) {
    e.preventDefault()
    this.element.classList.remove('drag-over')
  }

  onDrop(e) {
    e.preventDefault();
    this.inputTarget.files = e.dataTransfer.files
    this.fileReader.readAsDataURL(this.inputTarget.files[0])
    this.element.classList.remove('drag-over')
  }
}